<template>
  <div class="qvp-kids-final-page">
    <div class="page-wrapper">
      <header class="logo-header-card">
        <img
          src="https://guideportal.wisdomislam.org/uploads/image/1770639267.png"
          alt="QVP Kids"
          class="kids-logo"
          @error="onLogoError"
        />
        <img
          src="/assets/img/QVP NEW LOGO HRIDAYAM.png"
          alt="QVP"
          class="corner-qvp-logo"
          @error="onQvpLogoError"
        />
        <p class="header-sub mal-text">QVP Kids – Final Examination Result</p>
      </header>

      <div v-if="alertMessage" class="alert-box" :class="alertClass">{{ alertMessage }}</div>

      <!-- Mobile lookup -->
      <div class="step-panel" v-show="currentStep === 'mobile'">
        <form class="lookup-form main-card" @submit.prevent="handleMobileSubmit">
          <div class="mobile-row">
            <div class="form-group code-group">
              <label class="form-label mal-text">Code <span class="req">*</span></label>
              <select v-model="mobileCountryCode" class="form-input" required>
                <option value="91">+91 India</option>
                <option value="971">+971 UAE</option>
                <option value="966">+966 Saudi</option>
                <option value="974">+974 Qatar</option>
                <option value="965">+965 Kuwait</option>
                <option value="973">+973 Bahrain</option>
                <option value="968">+968 Oman</option>
              </select>
            </div>
            <div class="form-group mobile-group">
              <label class="form-label mal-text">Mobile Number <span class="req">*</span></label>
              <input
                type="tel"
                v-model="mobileInput"
                class="form-input"
                :placeholder="mobileCountryCode === '91' ? '10 Digit Number' : 'Enter Mobile Number'"
                :maxlength="mobileCountryCode === '91' ? 10 : 15"
                inputmode="numeric"
                required
              />
            </div>
          </div>
          <button type="submit" class="btn-primary mal-text" :disabled="loading">
            <span v-if="!loading">View Result</span>
            <span v-else class="btn-loading">Loading...</span>
          </button>
          <p class="hint mal-text">Enter your registered mobile number</p>
        </form>
      </div>

      <!-- Results -->
      <div class="step-panel" v-show="currentStep === 'results'">
        <div class="active-mobile-card main-card">
          <span class="number">+{{ mobileCountryCode }} {{ currentMobile }}</span>
          <button type="button" class="link-btn" @click="resetFlow">Change</button>
        </div>

        <div v-if="loading" class="loading-wrap">
          <div class="spinner"></div>
        </div>

        <template v-else>
          <div v-if="kidsWithResults.length" class="results-list">
            <article v-for="kid in kidsWithResults" :key="kid.id" class="result-card">
              <div class="result-card-head">
                <span class="result-card-label">Result Card</span>
                <span class="result-card-sub">QVP Kids Final Examination</span>
              </div>

              <div class="student-row">
                <div class="avatar">{{ initials(kid.name) }}</div>
                <div class="student-meta">
                  <h3 class="student-name">{{ kid.name }}</h3>
                  <p v-if="registrationNo(kid)" class="share-meta">Reg. No: {{ registrationNo(kid) }}</p>
                  <p v-if="placeLabel(kid)" class="share-meta">{{ placeLabel(kid) }}</p>
                </div>
              </div>

              <div v-if="hasFinalMark(kid)" class="final-mark-panel">
                <div class="final-mark-row">
                  <div class="mark-circle-wrap">
                    <div class="mark-circle">
                      <span class="mark-num">{{ finalMarkValue(kid) }}</span>
                      <span class="mark-denom">/75</span>
                    </div>
                    <p class="mark-label">Final Exam Mark</p>
                  </div>
                  <div
                    v-if="rankValue(kid) != null"
                    class="rank-pill-vertical"
                    :class="'rank-tier-' + rankTier(rankValue(kid))"
                  >
                    <span class="rank-emoji">{{ rankEmoji(rankValue(kid)) }}</span>
                    <span class="rank-lbl">RANK</span>
                    <span class="rank-val">{{ formatRank(rankValue(kid)) }}</span>
                  </div>
                </div>
              </div>

              <div v-if="hasPreliminaryMark(kid)" class="preliminary-row">
                <span class="prelim-label">Preliminary Exam Mark</span>
                <span class="prelim-score">{{ preliminaryMarkValue(kid) }}/50</span>
              </div>
            </article>
          </div>

          <div v-else-if="kidsRegistrations.length" class="empty-state main-card pending-state">
            <p class="mal-text">
              {{ kidsRegistrations.length }} കുട്ടി(കൾ) രജിസ്ട്രേഷൻ കണ്ടെത്തി. മാർക്ക് ഇനിയും പ്രസിദ്ധീകരിച്ചിട്ടില്ല.
            </p>
            <ul class="pending-names">
              <li v-for="kid in kidsRegistrations" :key="'pending-' + kid.id">{{ kid.name }}</li>
            </ul>
          </div>

          <div v-else class="empty-state main-card">
            <p class="mal-text">ഈ മൊബൈൽ നമ്പറിൽ QVP Kids രജിസ്ട്രേഷൻ കണ്ടെത്തിയില്ല.</p>
          </div>
        </template>
      </div>

      <footer v-if="currentStep === 'mobile'" class="page-footer mal-text">
        Wisdom Islamic Organization · QVP Kids
      </footer>
    </div>
  </div>
</template>

<script>
import UserService from "@/services/user.service";

export default {
  name: "QVPKidsFinalResult",
  data() {
    return {
      currentStep: "mobile",
      mobileCountryCode: "91",
      mobileInput: "",
      currentMobile: "",
      loading: false,
      alertMessage: "",
      alertClass: "",
      kidsRegistrations: [],
    };
  },
  computed: {
    kidsWithResults() {
      return (this.kidsRegistrations || []).filter((k) => this.hasAnyPublishedMark(k));
    },
  },
  mounted() {
    if (this.$root && this.$root.updateParent) {
      this.$root.updateParent("QVP Kids Final Result");
    }
    this.prefillLoggedInMobile();
  },
  methods: {
    prefillLoggedInMobile() {
      const user = this.$store?.state?.auth?.user;
      if (!user) return;
      const raw = String(user.mobile_number || user.mobile || user.phone || "").replace(/\D/g, "");
      if (!raw) return;
      const digits = raw.length > 10 ? raw.slice(-10) : raw;
      if (digits.length >= 7) {
        this.mobileInput = digits;
        if (user.country_code) {
          this.mobileCountryCode = String(user.country_code).replace(/\D/g, "") || "91";
        }
      }
    },
    normalizeMobile(raw) {
      return String(raw || "").replace(/\D/g, "");
    },
    registrationNo(kid) {
      if (!kid) return "";
      if (kid.qhls_reg_no != null && String(kid.qhls_reg_no).trim() !== "") {
        return String(kid.qhls_reg_no).trim();
      }
      return kid.id != null ? String(kid.id) : "";
    },
    placeLabel(kid) {
      const parts = [kid.district_name, kid.zone_name, kid.place, kid.unit_name]
        .map((x) => (x != null ? String(x).trim() : ""))
        .filter(Boolean);
      return parts.join(", ");
    },
    initials(name) {
      const n = String(name || "").trim();
      if (!n) return "?";
      const parts = n.split(/\s+/).filter(Boolean);
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    },
    markNum(val) {
      if (val === null || val === undefined || val === "") return null;
      const n = Number(val);
      return Number.isNaN(n) ? null : n;
    },
    hasFinalMark(kid) {
      return this.markNum(kid?.qvp_final_exam_mark) != null;
    },
    hasPreliminaryMark(kid) {
      const raw = kid?.qvp_exam_mark ?? kid?.marks_scored ?? kid?.mark ?? kid?.total_mark;
      return this.markNum(raw) != null;
    },
    hasAnyPublishedMark(kid) {
      return this.hasFinalMark(kid) || this.hasPreliminaryMark(kid);
    },
    finalMarkValue(kid) {
      const n = this.markNum(kid?.qvp_final_exam_mark);
      return n != null ? n : "-";
    },
    preliminaryMarkValue(kid) {
      const raw = kid?.qvp_exam_mark ?? kid?.marks_scored ?? kid?.mark ?? kid?.total_mark;
      const n = this.markNum(raw);
      return n != null ? n : "-";
    },
    rankValue(kid) {
      const raw = kid?.qvp_final_exam_rank ?? kid?.rank;
      if (raw === null || raw === undefined || raw === "") return null;
      const n = parseInt(String(raw), 10);
      return Number.isNaN(n) ? null : n;
    },
    formatRank(rank) {
      const n = parseInt(String(rank), 10);
      if (Number.isNaN(n)) return String(rank);
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      const suffix = s[(v - 20) % 10] || s[v] || s[0];
      return n + suffix;
    },
    rankTier(rank) {
      const n = parseInt(String(rank), 10);
      if (n === 1) return "gold";
      if (n === 2) return "silver";
      if (n === 3) return "bronze";
      return "default";
    },
    rankEmoji(rank) {
      const n = parseInt(String(rank), 10);
      if (n === 1) return "🥇";
      if (n === 2) return "🥈";
      if (n === 3) return "🥉";
      return "🏆";
    },
    showAlert(msg, type) {
      this.alertMessage = msg;
      this.alertClass = type === "error" ? "alert-error" : "alert-success";
    },
    hideAlert() {
      this.alertMessage = "";
      this.alertClass = "";
    },
    resetFlow() {
      this.currentStep = "mobile";
      this.kidsRegistrations = [];
      this.hideAlert();
    },
    onLogoError(e) {
      if (e?.target) e.target.style.display = "none";
    },
    onQvpLogoError(e) {
      if (e?.target) e.target.src = "/assets/img/logo.png";
    },
    async handleMobileSubmit() {
      const mobile = this.normalizeMobile(this.mobileInput);
      if (this.mobileCountryCode === "91") {
        if (mobile.length !== 10) {
          this.showAlert("ദയവായി സാധുവായ 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക", "error");
          return;
        }
      } else if (mobile.length < 7 || mobile.length > 15) {
        this.showAlert("Please enter a valid mobile number (7-15 digits)", "error");
        return;
      }

      this.loading = true;
      this.hideAlert();
      this.currentMobile = mobile;
      this.kidsRegistrations = [];

      try {
        const response = await UserService.PostRequest("public/qvp/my-registration", {
          mobile,
          code: this.mobileCountryCode,
        });
        const data = response?.data;
        if (data?.status === "success" && Array.isArray(data.data)) {
          this.kidsRegistrations = data.data.filter(
            (r) => String(r.category || "").toLowerCase() === "kids"
          );
          this.currentStep = "results";
          if (!this.kidsRegistrations.length) {
            this.showAlert("ഈ മൊബൈൽ നമ്പറിൽ QVP Kids രജിസ്ട്രേഷൻ കണ്ടെത്തിയില്ല.", "error");
          }
        } else {
          this.showAlert(data?.message || "എന്തോ തെറ്റ് സംഭവിച്ചു. വീണ്ടും ശ്രമിക്കുക.", "error");
        }
      } catch (e) {
        const msg =
          e?.response?.data?.message ||
          e?.message ||
          "Unable to load results. Please check your connection and try again.";
        this.showAlert(msg, "error");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
#appCapsule.qvp-page {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  background: #f5f7f8 !important;
}
</style>

<style scoped>
.qvp-kids-final-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #f5f7f8;
  color: #1f2937;
  min-height: 100vh;
  padding: 10px 14px 20px;
  padding-bottom: max(20px, env(safe-area-inset-bottom));
}

.page-wrapper {
  max-width: 480px;
  margin: 0 auto;
}

.logo-header-card {
  position: relative;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 14px 12px;
  margin-bottom: 12px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.kids-logo {
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto 8px;
}

.corner-qvp-logo {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: auto;
}

.header-sub {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

.alert-box {
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 14px;
}
.alert-error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}
.alert-success {
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.main-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.lookup-form .form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}
.req {
  color: #dc2626;
}
.mobile-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.code-group {
  flex: 0 0 38%;
}
.mobile-group {
  flex: 1;
}
.form-input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  background: #fff;
}
.btn-primary {
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  background: #1a6369;
  color: #fff;
  margin-top: 4px;
}
.btn-primary:disabled {
  opacity: 0.65;
}
.hint {
  text-align: center;
  font-size: 12px;
  color: #6b7280;
  margin: 10px 0 0;
}

.active-mobile-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 10px;
}
.active-mobile-card .number {
  font-weight: 600;
  color: #1a6369;
}
.link-btn {
  border: none;
  background: transparent;
  color: #1a6369;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 4px;
  min-height: 44px;
}

.loading-wrap {
  text-align: center;
  padding: 24px;
}
.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e5e7eb;
  border-top-color: #1a6369;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.results-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.result-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.result-card-head {
  padding: 10px 14px;
  border-bottom: 1px solid #f3f4f6;
  background: #fafafa;
}
.result-card-label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #1a6369;
}
.result-card-sub {
  font-size: 11px;
  color: #9ca3af;
}

.student-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-bottom: 1px solid #f3f4f6;
}
.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e0f2f1;
  color: #1a6369;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.student-name {
  margin: 0 0 4px;
  font-size: 17px;
  font-weight: 700;
  color: #111827;
}
.share-meta {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.4;
}

.final-mark-panel {
  padding: 14px;
  background: #f0fdfa;
}
.final-mark-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}
.mark-circle-wrap {
  text-align: center;
}
.mark-circle {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  border: 3px solid #5b4282;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 6px;
}
.mark-num {
  font-size: 36px;
  font-weight: 800;
  color: #5b4282;
  line-height: 1;
}
.mark-denom {
  font-size: 16px;
  font-weight: 600;
  color: #6b7280;
}
.mark-label {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1a6369;
}

.rank-pill-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  height: 112px;
  border-radius: 12px;
  padding: 8px 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.rank-pill-vertical .rank-emoji {
  font-size: 28px;
  line-height: 1;
}
.rank-pill-vertical .rank-lbl {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  margin-top: 4px;
  opacity: 0.9;
}
.rank-pill-vertical .rank-val {
  font-size: 18px;
  font-weight: 800;
  margin-top: 2px;
}
.rank-tier-gold {
  background: linear-gradient(160deg, #fcd34d, #f59e0b);
  color: #78350f;
}
.rank-tier-silver {
  background: linear-gradient(160deg, #e5e7eb, #9ca3af);
  color: #374151;
}
.rank-tier-bronze {
  background: linear-gradient(160deg, #fdba74, #c2410c);
  color: #fff;
}
.rank-tier-default {
  background: linear-gradient(160deg, #99f6e4, #1a6369);
  color: #134e4a;
}

.preliminary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #f9fafb;
  border-top: 1px dashed #d1d5db;
}
.prelim-label {
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
}
.prelim-score {
  font-size: 18px;
  font-weight: 700;
  color: #5b4282;
}

.empty-state {
  text-align: center;
  padding: 20px 14px;
  color: #4b5563;
  font-size: 14px;
}
.pending-names {
  list-style: none;
  padding: 0;
  margin: 12px 0 0;
  text-align: left;
}
.pending-names li {
  padding: 6px 0;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
}

.page-footer {
  text-align: center;
  font-size: 11px;
  color: #9ca3af;
  margin-top: 16px;
}

@media (max-width: 340px) {
  .final-mark-row {
    flex-direction: column;
  }
}
</style>
